// Fase 7 (evolução do módulo 3D, combinada com o usuário): checagem barata
// de suporte a WebGL, feita ANTES de tentar montar o Canvas do
// VehicleInspection3D. Alguns navegadores/dispositivos antigos, ou com
// aceleração de hardware desativada, não suportam WebGL -- sem essa
// checagem, o three.js lançaria uma exceção ao tentar criar o contexto,
// e sem um Error Boundary isso derrubaria o checklist inteiro.
export function hasWebGL() {
  try {
    const canvas = document.createElement("canvas");
    return !!(
      window.WebGLRenderingContext &&
      (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"))
    );
  } catch (e) {
    return false;
  }
}
